module.exports = __webpack_public_path__ + "static/media/hangry_hero.8097b01b.png";